import type { SVGProps } from 'react';

const Transfer = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M12.75 9.75082L16 6.25082M16 6.25082L19.25 9.75082M16 6.25082V13.7508M19.25 15.2508C19.25 15.2508 17.321 17.3408 16.357 19.7508L14.75 17.8218M11.25 15.2508L8 18.7508M8 18.7508L4.75 15.2508M8 18.7508V6.25082"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Transfer;
